import * as React from "react";

import { PurchaseOrdersContext } from "./PurchaseOrdersProvider";

export const usePurchaseOrdersState = () => {
  return React.useContext(PurchaseOrdersContext);
};
